<template>
  <el-main class="container">
    <Nav>
      <div class="left" slot="left">
        <el-input
          clearable
          class="input-text"
          v-model="body.word"
          maxlength="99"
          placeholder="请输入车牌号搜索"/>
        <el-button type="primary" @click="event().search()">搜索</el-button>
        <div class="industry-box">
          <span>产业筛选</span>
          <el-select v-model="selectIndustry" @change="handleIndustry()" clearable>
            <el-option
              v-for="item in industryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="select-date">
          <span>选择日期</span>
          <el-date-picker
            v-model="value1"
            type="daterange"
            clearable
            @change="event().selectDate($event)"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </div>
      <div class="right" slot="right">
        <el-button
          v-show="hasAuthority('parkRecordExcel')"
          ype="primary"
          class="excel"
          :idRow="false"
          @click="network().getParkExcel()"
          type="primary">
          导出Excel</el-button>
      </div>
    </Nav>
    <!-- <table-pagination
      ref="table"
      class="table"
      :config="config"
      :datasource="datasource"
      :idRow="false"
      @change-page="handlerPageChange">
    </table-pagination> -->
    <div class="table-box">
      <Table
        border
        :header-row-style="{height: '100px'}"
        :header-cell-style="{background:'#f4f4f4',color:'#606266'}"
        :row-style="{height: '150px'}"
        align="center"
        :column="column"
        :data="datasource.data"
        pagination
        background
        :paginationTop="'30px'"
        :paginationAlign="'center'"
        layout="prev, pager, next, sizes, jumper"
        :page-sizes="[5, 10, 20, 30]"
        :pager-count="5"
        :current-page.sync="body.pageIndex"
        :total="datasource.total"
        :page-size="body.pageSize"
        @size-change="handleSizeChange"
        @p-current-change="handleCurrentChange"
      >
      </Table>
    </div>
  </el-main>
</template>

<script>
import Nav from '@/components/nav'
// import TablePagination from '@/components/table-pagination'
import { getParkList, getParkExcel } from '@/api/park'
import { getIndustrySelectList } from '@/api/industry'
import { ExchangeDate } from '@/jslib/utils'
import utils from '@/jslib/utils'
export default {
  data() {
    return {
      body: {
        word: '',
        pageSize: 10,
        pageIndex: 1,
        startTime: '',
        endTime: '',
        industryUuid: ''
      },
      excelBody: {
        startTime: '',
        endTime: '',
        word: ''
      },
      industryList: [],
      column: [
        {
          prop: 'userName',
          label: '用户名称'
        },
        {
          prop: 'userMobile',
          label: '用户手机号'
        },
        {
          prop: 'industryName',
          label: '所在产业'
        },
        {
          prop: 'carNumber',
          label: '车牌号'
        },
        {
          prop: 'entryTime',
          label: '进场时间'
        },
        {
          prop: 'outTime',
          label: '出场时间'
        },
        {
          prop: 'payablePrice',
          label: '应付金额'
        },
        {
          prop: 'couponName',
          label: '使用优惠'
        },
        {
          prop: 'actuallyPrice',
          label: '实付金额'
        }
      ],
      datasource: {
        data: [],
        total: 0
      },
      config: {
        size: 10,
        fields: [
          {
            prop: 'carNumber',
            label: '车牌号',
            width: '200'
          },
          {
            prop: 'entryTime',
            label: '进场时间'
          },
          {
            prop: 'outTime',
            label: '出场时间'
          },
          {
            prop: 'payablePrice',
            label: '应付金额'
          },
          {
            prop: 'couponName',
            label: '使用优惠',
            type: 'show',
            rule: [
              {
                value: '-',
                label: ''
              }
            ]
          },
          {
            prop: 'actuallyPrice',
            label: '实付金额'
          }
        ]
      },
      value1: '',
      selectIndustry: ''
    }
  },
  created() {
    this.network().getParkList()
    this.network().getIndustrySelectList()
  },
  methods: {
    event() {
      return {
        search: () => {
          this.network().getParkList()
        },
        selectDate: (e) => {
          if (e == null) {
            this.body.endTime = ''
            this.body.startTime = ''
          } else {
            this.body.startTime = ExchangeDate(this.value1[0])
            this.body.endTime = ExchangeDate(this.value1[1])
          }
          this.network().getParkList()
        }
      }
    },
    network() {
      return {
        getParkList: async() => {
          const { data } = await getParkList(this.body)
          this.datasource.total = data.total
          this.datasource.data = data.list
        },
        getParkExcel: async() => {
          this.excelBody.startTime = this.body.startTime
          this.excelBody.endTime = this.body.endTime
          this.excelBody.word = this.body.word
          console.log(this.excelBody)
          const { data } = await getParkExcel(this.excelBody)
          utils.exportExcel(data, '导出停车记录excel')
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        }
      }
    },
    handlerPageChange(data) {
      this.body.pageIndex = data.page
      this.network().getParkList()
    },
    handleSizeChange(val) {

    },
    handleCurrentChange() {

    },
    handleIndustry() {
      this.body.industryUuid = this.selectIndustry
      this.body.pageIndex = 1
      this.network().getParkList()
    }
  },
  components: {
    Nav
    // TablePagination
  }
}
</script>

<style scoped lang="scss">
.container{
  Nav{
    margin-bottom: 15px;
  }
  .select-date{
    display: flex;
    align-items: center;
    margin-left: 90px;
    span{
      margin-right: 15px;
    }
  }

  /deep/ .table{
    /deep/ .el-table__body .el-table__row{
      height: 60px;
    }
  }

  .industry-box{
    margin-left: 60px;
    span{
      min-width: 100px;
      margin-right: 15px;
    }
  }

}
</style>
